import Box from '@mui/material/Box';
import { SectionTitle, DefinitionList } from '../components/SectionPrimitives';

export function Section1(): JSX.Element {
  return (
    <Box>
      <SectionTitle>1. Definitions</SectionTitle>
      <DefinitionList
        items={[
          {
            term: '"Agreement"',
            definition:
              'means the relevant contract document signed by both parties, together with these Terms.',
          },
          {
            term: '"Partner"',
            definition:
              'means the vineyard, business, or organisation entering into the Agreement with UKVG.',
          },
          {
            term: '"Platform"',
            definition:
              'means the UK Vineyard Guide app, website, and associated digital services operated by UKVG.',
          },
          {
            term: '"Subscription Period" or "Agreement Period"',
            definition:
              'means the 12-month term commencing from the date payment is received.',
          },
        ]}
      />
    </Box>
  );
}
